module.exports = __webpack_public_path__ + "montserrat-medium-webfont.cb3ba794bc0ff25b229a.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-medium-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-medium-webfont.woff
// module chunks = styles